module.exports = __webpack_public_path__ + "static/media/partners.9e8671b1.webp";